import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

const StyledLeftHalf = styled.div`
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 8px;
  min-width: 0;
`

const LeftHalf: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledLeftHalf>{children}</StyledLeftHalf>

export default LeftHalf
